var _defs, _line, _line2, _line3, _line4, _line5, _line6, _circle, _circle2, _text, _circle3, _circle4, _text2, _circle5, _circle6, _text3, _circle7, _text4, _circle8, _text5, _circle9, _text6, _circle0, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatina(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa-node",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5a2fa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b45ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa-root",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3d1f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8030ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa-leaf",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6b35c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b06aff"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 56,
    x2: 74,
    y2: 84,
    stroke: "white",
    strokeOpacity: 0.22,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: 56,
    x2: 126,
    y2: 84,
    stroke: "white",
    strokeOpacity: 0.22,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 114,
    x2: 44,
    y2: 145,
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 114,
    x2: 86,
    y2: 145,
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 126,
    y1: 114,
    x2: 114,
    y2: 145,
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 143,
    y1: 114,
    x2: 156,
    y2: 145,
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 40,
    r: 21,
    fill: "url(#pa-root)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 40,
    r: 21,
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 1.5,
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 46,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: "bold",
    fill: "white"
  }, "S")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 100,
    r: 17,
    fill: "url(#pa-node)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 100,
    r: 17,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1,
    fill: "none"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 105,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fontWeight: "bold",
    fill: "white"
  }, "E")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 100,
    r: 17,
    fill: "url(#pa-node)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 100,
    r: 17,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1,
    fill: "none"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 105,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fontWeight: "bold",
    fill: "white"
  }, "T")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 160,
    r: 13,
    fill: "url(#pa-leaf)",
    fillOpacity: 0.75
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 165,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "white",
    fillOpacity: 0.9
  }, "a")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 160,
    r: 13,
    fill: "url(#pa-leaf)",
    fillOpacity: 0.75
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 165,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 12,
    fill: "white",
    fillOpacity: 0.9
  }, "+")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 160,
    r: 13,
    fill: "url(#pa-leaf)",
    fillOpacity: 0.75
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 165,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "white",
    fillOpacity: 0.9
  }, "b")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 13,
    fill: "url(#pa-leaf)",
    fillOpacity: 0.75
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 165,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 12,
    fill: "white",
    fillOpacity: 0.9
  }, "\xD7")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatina);
export default __webpack_public_path__ + "static/media/patina.b3b787937d4da22da1f8bf6db198a5b2.svg";
export { ForwardRef as ReactComponent };